import { RootState } from "RootReducer";

export const selectWholesaleList = (root: RootState) => root.wholesaleList;

export const selectWholesaleListSearchFilters = (root: RootState) => root.wholesaleList.searchFilters;
